module.exports = __webpack_public_path__ + "img/img-60aef5.png";